import * as firebase from 'firebase/app';
import 'firebase/analytics';

export default class MetricsHelper {
  static logEvent(name: string, params?:  { [key: string]: any }) {
    firebase.analytics().logEvent(name, params || []);
  }
}
